import Tools from "@/shared/services/tools";
import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gSteps from "@/components/g-steps/g-steps.vue";
import gButton from '@/components/g-button/g-button.vue'
import gCardResumo from '@/components/g-card-resumo/g-card-resumo.vue'
import gMenuSidebar from "@/components/g-menu-sidebar/g-menu-sidebar.vue";

const name = 'ProdutoRepeticaoAlteracao'

export default {
    
  name,

  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-button' : gButton,
    'g-steps' : gSteps,
    'g-card-resumo' : gCardResumo,
    'g-menu-sidebar': gMenuSidebar 
   }, 

  props: { },

  setup(){
    
  },
  mounted () { },

  updated () { },

  data () {
    return {
        MascaraCnpj: {},
        nomeComponente: '',
        orcamentoId: this.$route.params.id,
        resumoObj: [],
        resumoobj: {},
        resumoObjComp: [],
        steps: 0,
        items: [
            {
                label: '',
                icon: "pi pi-user",
                to: `/produto-repeticao-alteracao/${this.$route.params.id}/info-cliente-ra`,
            },
            {
                label: '',
                icon: "pi pi-car",
                to: `/produto-repeticao-alteracao/${this.$route.params.id}/lote-frete-ra`,
            },
            {
                label: '',
                icon: "pi pi-box",
                to: `/produto-repeticao-alteracao/${this.$route.params.id}/info-basicas-ra`,
            },
            {
                label: '',
                icon: "pi pi-arrows-v",
                to: `/produto-repeticao-alteracao/${this.$route.params.id}/componentes-produto-ra`,
            },
            {
                label: '',
                icon: "pi pi-star-fill",
                to: `/produto-repeticao-alteracao/${this.$route.params.id}/caracteristicas-produto-ra`,
            }
        ],
        rotaAtual: ''
    }
  },

  methods: { 
    continuar() {
        this.$router.push('/produto-repeticao-alteracao')
      },

      verificarTabs (index) {
        this.steps = index
        if (index == 0 || index == 1) {
          this.pupulaResumoLateralStep0e1()
        }
        else if (index == 2) {
          this.pupulaResumoLateralStep2()
        }
        else if (index == 3 || index == 4 ){
          this.pupulaResumoLateralStep3e4()
          this.pupulaQuantidadeDataCarregResumoLateral()
          this.pupulaComponentesResumoLateral()
        }
      },

      pupulaResumoLateralStep0e1(){
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `Orcamento/GetOrcamentoResumoLateral/${this.orcamentoId}`,
        })
          .then((response) => {
            this.resumoobj = response.data.data;
            this.MascaraCnpj = Tools.formatarCnpj(response.data.data.cnpj)
          })
          .catch(() => {
          });
      },
      pupulaResumoLateralStep2() {
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `Orcamento/GetOrcamentoResumoLateralLoteFrete/${this.orcamentoId}`,
        })
          .then((response) => {
            this.resumoobj = response.data.data;
            this.MascaraCnpj = Tools.formatarCnpj(response.data.data.cnpj)
          })
          .catch(() => {
          });
      },
  
      pupulaResumoLateralStep3e4() {
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `Orcamento/GetOrcamentoResumoLateralProduto/${this.orcamentoId}`,
        })
        .then((response) => {
          if(response.data.code == 200){
            this.resumoobj = response.data.data;
            this.MascaraCnpj = Tools.formatarCnpj(response.data.data.cnpj)
          }
        })
        .catch(() => {
        });
      },

      pupulaQuantidadeDataCarregResumoLateral() {
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `Orcamento/GetQuantidadeDataCarregamentoResumoLateral/${this.orcamentoId}`,
        })
        .then((response) => {
          this.resumoObj = response.data.data;
        })
        .catch(() => {
        });
      },

      pupulaComponentesResumoLateral() {
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `Orcamento/GetComponentesResumoLateral/${this.orcamentoId}`,
        })
        .then((response) => {
          this.resumoObjComp = response.data.data;
          this.nomeComponente = response.data.data.componenteTipoText;
        })
        .catch(() => {
        });
      },
  },

  computed: { }, 

};